// removed by extract-text-webpack-plugin
module.exports = {"link":"style__link___Jv1rj","linkList":"style__linkList___3HuTR","time":"style__time___uyBDQ","detail":"style__detail___1ZV8G","container":"style__container___2QbfQ","appBar":"style__appBar___20BnR","navLink":"style__navLink___3m_kJ","footer":"style__footer___vckbr"};


//////////////////
// WEBPACK FOOTER
// ./src/frames/style.scss
// module id = 538
// module chunks = 0